import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  triggerName: 'inquiry',
  namespace: 'INQUIRY',
  entryPoint: '/inquiries',
  collectionName: 'inquiries',
  querySearchListing: [
    [
      'reference', 'creation_date', 'processed', 'status', 'arrival_date', 'departure_date', 'origin',
      ['customer', ['name'] ],
      ['property', ['name'] ],
    ],
  ],
  quickSearch: (keyword) => ({ $any: [{ reference: { match: keyword } }, { 'customer.name': { match: keyword } }, { 'customer.entity.primary_email': { match: keyword } }] }),
  filters: {
    // new: () => ({ status: 'new' }),
    pending: () => ({ processed: false }),
    // processing: () => ({ status: 'processing' }),
    processed: () => ({ processed: true }),
    // aborted: () => ({ status: 'aborted' }),
  },
  successMessageCreate: 'Inquiry created',
  successMessageUpdate: 'Inquiry updated',
  successMessageDelete: 'Inquiry deleted',
});

export default {
  ...triggers,
  sendEmail(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/inquiries/${id}/send-email`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  requestInformation(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/inquiries/${id}/request-information`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  confirmAvailability(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/inquiries/${id}/confirm-availability`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  sendAlternativeOffer(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/inquiries/${id}/send-email`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  notifyUnavailable(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/inquiries/${id}/notify-unavailable`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  processLater(dispatch, getState, { id }) {
    const url = config.APP_URL + `/inquiries/${id}/process-later`;
    return doItemAction(dispatch, getState, { id, url });
  },
  reject(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/inquiries/${id}/reject`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  createOffer(dispatch, getState, { id, message, blockDates }) {
    const url = config.APP_URL + `/inquiries/${id}/create-offer`;
    return doItemAction(dispatch, getState, { id, message, blockDates, url })
      .then(createdReservation => {
        dispatch({ type: 'INQUIRY__SET_DATA', payload: { createdReservation } });
      });
  },
  // abort(dispatch, getState, { id }) {
  //   const url = config.APP_URL + `/inquiries/${id}/abort`;
  //   return doItemAction(dispatch, getState, { id, url });
  // },
  sendEmail(dispatch, getState, { id, message }) {
    const url = config.APP_URL + `/inquiries/${id}/send-email`;
    return doItemAction(dispatch, getState, { id, message, url });
  },
  // continue(dispatch, getState, { id }) {
  //   const url = config.APP_URL + `/inquiries/${id}/continue`;
  //   return doItemAction(dispatch, getState, { id, url });
  // },
  removeError(dispatch, getState, { id }) {
    const url = config.APP_URL + `/inquiries/${id}/remove-error`;
    return doItemAction(dispatch, getState, { id, url });
  },
};

function doItemAction(dispatch, getState, params) {
  const { id, url, message, ...otherParams } = params;
  dispatch({ type: 'INQUIRY__POST_DATA' });
  const data = message ? { message: { ...message, id: 0 } } : {};
  return httpRequest('POST', params.url, { ...data, ...otherParams })
    .then(res => {
      dispatch({ type: 'INQUIRY__POST_DATA_SUCCESS' });
      dispatch({ type: 'INQUIRY__SET_DATA', payload: { actionSuccessful: true} });
      return res;
    })
    .catch(err => {
      dispatch({ type: 'INQUIRY__ERROR', payload: err });
    });
}



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/inquiry/triggers.js